<div *ngIf="passwordSecurity" class="login">
  <div class="login__header">
    <div class="login__header__left">

      <div class="login__header__logo ">
        <img src="assets/img/appoint360-logo.png" height="80" width="107" title="Appoint360" alt="Appoint360">
      </div>

      <div class="login__header__client-logo">
        <div class="login__header__client-logo__client ">
          <img *ngIf="imageUrl" [src]="imageUrl" alt="{{imagealt}}" title="{{imageTitle}}" height="65">
        </div>
      </div>
    </div>
  </div>

  <div class="login__content">
    <div class="login__content__left">
      <div class="login-img">
        <img src="assets/img/login-img.png" class="login__content__left__img" alt="login img" width="581" height="510">
      </div>
    </div>
    <div class="login__content__right">
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <h2 style="margin-bottom: 1.2rem;">{{title}}</h2>
        <div class="scroll-div">
          <!-- New UI -->
          <div class="form__password-block"
            [ngClass]="{'weak': passwordStrength === 'Weak', 'medium': passwordStrength === 'Medium', 'strong': passwordStrength === 'Strong'}">

            <div class="form__group">
              <label class="form__label">New Password</label>
              <p-password class="form__p-password" [feedback]="false" formControlName="newPassword" maxlength="25"
                [toggleMask]="true" (input)="onPasswordInput()"> </p-password>
            </div>

            <div class="form__password-strength">
              <div class="form__strengths weak"><span>Weak</span></div>
              <div class="form__strengths medium"><span>Medium</span></div>
              <div class="form__strengths strong"><span>Strong</span></div>
            </div>
            <div class="info-box">
              <h3 class="info-box__title">
                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M9.5 0C4.532 0 0.5 4.032 0.5 9C0.5 13.968 4.532 18 9.5 18C14.468 18 18.5 13.968 18.5 9C18.5 4.032 14.468 0 9.5 0ZM10.4 13.5H8.6V8.1H10.4V13.5ZM10.4 6.3H8.6V4.5H10.4V6.3Z"
                    fill="#666666" />
                </svg>
                Your password must include:
              </h3>

              <ul class="info-box__list">
                <li class="info-box__item" *ngFor="let rule of validationRules">
                  <svg *ngIf="!this[rule.key]" class="info-box__no" width="13" height="12" viewBox="0 0 13 12" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.5 11L1.5 1M11.5 1L1.5 11" stroke="#FF1F1F" stroke-width="2" stroke-linecap="round" />
                  </svg>
                  <svg *ngIf="this[rule.key]" class="info-box__yes" width="15" height="14" viewBox="0 0 15 14" fill="none"
                    xmlns="http://www.w3.org/2000/svg">
                    <path d="M1.5 8.81818C1.5 8.81818 2.78571 8.81818 4.5 12C4.5 12 9.26486 3.66636 13.5 2"
                      stroke="#9CAF2E" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                  <span [innerHTML]="rule.message"></span>
                </li>
              </ul>

            </div>
          </div>
          <div class="form__group">
            <label class="form__label">Confirm New Password</label>
            <input class="form__control" formControlName="confirmPassword" type="password" pInputText
              appConfirmEqualValidator='newPassword' maxlength="25">
            <span class="invalid-feedback"
              *ngIf="hasError(formFields.confirmPassword, 'required')">{{validationMessages.confirmPassword.required}}</span>
            <span class="invalid-feedback"
              *ngIf="form.hasError('validPasswordMatch')">{{validationMessages.confirmPassword.validPasswordMatch}}</span>
          </div>
        </div>
        <div class="form__group login-btn">
          <button class="btn btn--primary">Set Password</button>
        </div>
      </form>
    </div>
  </div>
  <div class="login__footer">
    <div class="login__footer__left mobile-support">
      <h4>Appoint360 is best viewed on resolution width 1024 or greater</h4>
      <p><strong>For Windows OS:</strong> Google Chrome 88+, Mozilla Firefox 84+, Microsoft Edge 101+ browsers.</p>
      <p><strong>For Mac OS:</strong> Safari 13.1+, Google Chrome 88+, Mozilla Firefox 84+ browsers.</p>
    </div>
    <!-- <p class="login__footer__left mobile-support">*Application best view in 1280px + resolutions in <strong>Google Chrome, Mozilla Firefox & Microsoft Edge</strong> browsers.</p> -->

    <div class="login__footer__right">
      <span>Powered By<img src="assets/img/appoint360-logo.svg" alt="Appoint360" title="Appoint360" width="20"
          height="13">Appoint360</span>
    </div>
  </div>
</div>


<div *ngIf="!passwordSecurity" class="login">
  <div class="login__header">
    <div class="login__header__left">

      <div class="login__header__logo ">
        <img src="assets/img/appoint360-logo.png" height="80" width="107" title="Appoint360" alt="Appoint360">
      </div>

      <div class="login__header__client-logo">
        <div class="login__header__client-logo__client ">
          <img *ngIf="imageUrl" [src]="imageUrl" alt="{{imagealt}}" title="{{imageTitle}}" height="65">
        </div>
      </div>
    </div>
  </div>

  <div class="login__content">
    <div class="login__content__left">
      <div class="login-img">
        <img src="assets/img/login-img.png" class="login__content__left__img" alt="login img" width="581" height="510">
      </div>
    </div>
    <div class="login__content__right">
      <form class="form" [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
        <h2>{{title}}</h2>
        <div class="form__group" *ngIf="false">
          <input class="form__control" formControlName="email" type="email" placeholder="Email" required pInputText>
          <!--<span *ngIf="hasError(formFields.email,'required')"
          class="error-msg">{{commonValidationMessages.email.required}}</span>
          <span *ngIf="hasError(formFields.email,'email')"
          class="error-msg">{{commonValidationMessages.email.email}}</span>-->
        </div>
        <div class="form__group">
          <input class="form__control" formControlName="newPassword" type="password" placeholder="New password" required
            pInputText>
          <p>
            [Password must contain minimum 8 characters length, at least one upper case letter, one lower case letter,
            one special character, one numeric character.]
          </p>
          <span *ngIf="hasError(formFields.newPassword, 'required')"
            class="error-msg">{{validationMessages.newPassword.required}}</span>
          <span *ngIf="hasError(formFields.newPassword, 'validStrongPassword')"
            class="error-msg">{{validationMessages.newPassword.invalid}}</span>
        </div>
        <div class="form__group">
          <input class="form__control" formControlName="confirmPassword" type="password" placeholder="Confirm password"
            required pInputText appConfirmEqualValidator='newPassword'>
          <span *ngIf="hasError(formFields.confirmPassword, 'required')"
            class="error-msg">{{validationMessages.confirmPassword.required}}</span>
          <!-- <span *ngIf="hasError(formFields.confirmPassword, 'validStrongPassword')"
          class="error-msg">{{validationMessages.confirmPassword.invalid}}</span> -->
          <span *ngIf="form.hasError('validPasswordMatch')"
            class="error-msg">{{validationMessages.confirmPassword.validPasswordMatch}}</span>
        </div>
        <div class="form__group login-btn">
          <button class="btn btn--primary">Set Password</button>
        </div>
      </form>
    </div>
  </div>
  <div class="login__footer">
    <div class="login__footer__left mobile-support">
      <h4>Appoint360 is best viewed on resolution width 1024 or greater</h4>
      <p><strong>For Windows OS:</strong> Google Chrome 88+, Mozilla Firefox 84+, Microsoft Edge 101+ browsers.</p>
      <p><strong>For Mac OS:</strong> Safari 13.1+, Google Chrome 88+, Mozilla Firefox 84+ browsers.</p>
    </div>
    <!-- <p class="login__footer__left mobile-support">*Application best view in 1280px + resolutions in <strong>Google Chrome, Mozilla Firefox & Microsoft Edge</strong> browsers.</p> -->

    <div class="login__footer__right">
      <span>Powered By<img src="assets/img/appoint360-logo.svg" alt="Appoint360" title="Appoint360" width="20"
          height="13">Appoint360</span>
    </div>
  </div>
</div>
